module.exports = __webpack_public_path__ + "static/img/026_TO8_1518_og.ba37c8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/026_TO8_1518_og.jpg
// module id = Lc6L
// module chunks = 0